<script setup>
import { orderBy } from 'lodash';
import { ge } from 'cifra-api-js';
import { ref, watch } from 'vue';
import SelectCifra from '../../../components/inputs/SelectCifra.vue';

const props = defineProps({
  multiple: { type: Boolean, value: true },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(props.modelValue);

const options = ref([]);

ge.modalidades.getAgrupadasSelect2({ params: {} }).then((data) => {
  options.value = orderBy(data, [(item) => item.text.toLowerCase()]);
});

watch(modelInterno, (value) => {
  emits('update:modelValue', value);
});

</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :options="options"
    :multiple="multiple"
    label="text"
    track-by="id"
  >
  </SelectCifra>
</template>
